const moduleUrl = '/module';

export default moduleUrl;
